import React from 'react';
import { connect } from 'react-redux';
import StatisticsByRefererMetrics from './StatisticsByRefererMetrics.js';
import actions from './StatisticsByRefererMetrics.actions';
import {
    mainSelector,
    getMetrics
} from './StatisticsByRefererMetrics.selectors';
import ReportByRefererComponent from '../../../../utils/ReportByRefererComponent/ReportByRefererComponent';

const reportUtils = ReportByRefererComponent.utils;

const StatisticsByRefererMetricsComponent = connect(
    function mapStateToProps(state, ownProps) {
        const data = mainSelector(state);
        const fallbackMetrics = getMetrics(state);
        const metrics = typeof ownProps.metrics === 'string' && ownProps.metrics.length
            ? ownProps.metrics
            : fallbackMetrics;
        const checkedKeys = reportUtils.getKeysMetric(metrics || reportUtils.getDefStrMetric());

        return {
            data,
            metrics,
            checkedKeys,
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsByRefererMetrics);

export default StatisticsByRefererMetricsComponent;
